import { BrandLogo } from '../components/BrandLogo'
import { Spinner } from '../components/Spinner'
import { LOGIN_COPY } from '../constants/auth'
import { LOADING_LABELS } from '../constants/loading'
import { APP_ROUTES } from '../constants/routes'
import { useLoginForm } from '../hooks/useLoginForm'
import '../styles/login-page.scss'

export function LoginPage() {
  const { form, error, submitting, onChange, onSubmit } = useLoginForm()

  return (
    <div className="login-page">
      <div className="login-page__shell">
        <aside className="login-page__panel">
          <div className="login-page__panel-glow" aria-hidden />
          <div className="login-page__panel-mark">
            <BrandLogo to={APP_ROUTES.login} />
          </div>
          <p className="login-page__eyebrow">{LOGIN_COPY.panelEyebrow}</p>
          <h1 className="login-page__panel-title">{LOGIN_COPY.panelTitle}</h1>
          <p className="login-page__panel-body">{LOGIN_COPY.panelBody}</p>
        </aside>

        <section className="login-page__content">
          <div className="login-page__content-inner">
            <header className="login-page__header">
              <h2>{LOGIN_COPY.title}</h2>
              <p>{LOGIN_COPY.subtitle}</p>
            </header>

            <form className="login-page__form" onSubmit={onSubmit} noValidate>
              <label className="login-field">
                <span>{LOGIN_COPY.emailLabel}</span>
                <input
                  type="email"
                  autoComplete="username"
                  required
                  placeholder={LOGIN_COPY.emailPlaceholder}
                  value={form.email}
                  onChange={(event) => onChange({ email: event.target.value })}
                  disabled={submitting}
                />
              </label>

              <label className="login-field">
                <span>{LOGIN_COPY.passwordLabel}</span>
                <input
                  type="password"
                  autoComplete="current-password"
                  required
                  minLength={8}
                  placeholder={LOGIN_COPY.passwordPlaceholder}
                  value={form.password}
                  onChange={(event) => onChange({ password: event.target.value })}
                  disabled={submitting}
                />
              </label>

              {error ? (
                <p className="login-page__error" role="alert">
                  {error}
                </p>
              ) : null}

              <button
                type="submit"
                className="login-page__submit"
                disabled={submitting}
                aria-busy={submitting}
              >
                {submitting ? (
                  <Spinner inline label={LOADING_LABELS.signingIn} />
                ) : (
                  LOGIN_COPY.submit
                )}
              </button>
            </form>
          </div>
        </section>
      </div>
    </div>
  )
}
